import { render, staticRenderFns } from "./VueDialog.vue?vue&type=template&id=557c7c14&"
import script from "./VueDialog.vue?vue&type=script&lang=js&"
export * from "./VueDialog.vue?vue&type=script&lang=js&"
import style0 from "./VueDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports